import ScheduleParticipants from "./ScheduleParticipants";
import ScheduleResult from "./ScheduleResult";

export default class Schedule {
    constructor(scheduleData) {
        this.id = scheduleData.id;
        this.created_at = scheduleData.created_at;
        this.updated_at = scheduleData.updated_at;
        this.event_id = scheduleData.event_id;
        this.race_nr = scheduleData.race_nr;
        this.planned_start_time = scheduleData.planned_start_time;
        this.race_start_time = scheduleData.race_start_time;
        this.boat = scheduleData.boat;
        this.gender = scheduleData.gender;
        this.category = scheduleData.category;
        this.distance = scheduleData.distance;
        this.race_type = scheduleData.race_type;
        this.participants = Array.isArray(scheduleData.participants)
            ? scheduleData.participants.map(p => new ScheduleParticipants(p)).sort((a, b) => a.start_nr - b.start_nr)
            : [];
        this.results = Array.isArray(scheduleData.results)
            ? sortResultsByOrder(scheduleData.results.map(r => new ScheduleResult(r)))
            : null;
    }
}

const sortResultsByOrder = (items) => {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.sort((a, b) => {
        const valA = parseInt(a.order, 10);
        const valB = parseInt(b.order, 10);

        const isANaN = isNaN(valA);
        const isBNaN = isNaN(valB);

        if (isANaN && isBNaN) return 0;
        if (isANaN) return 1;
        if (isBNaN) return -1;

        return valA - valB;
    });
};